import React, { useEffect, useState } from 'react'
import { Task, vehicleOverviewDto } from '../../interface'
import { Box, TextField } from '@mui/material'
import Grid from "@mui/material/Grid2";

export const VehicleInfo = ({ task }: { task: Task | undefined }) => {

  const [vehicleOverview, setvehicleOverview] = useState<vehicleOverviewDto | undefined>(undefined)

  useEffect(() => {
    setvehicleOverview(
      task?.vehicleOverview
    )
  }, [task])

  return (
    <Box sx={{ mt: 3 }}>
      <Grid container spacing={2}>
        <Grid size={4}>
          <TextField
            id="typeOfOdt"
            label="Tipo de ODT"
            value={`${vehicleOverview?.typeOfOdt || ""}`}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid size={4}>
          <TextField
            id="fieldOdt"
            label="Campo de ODT"
            value={`${vehicleOverview?.fieldOdt || ""}`}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid size={4}>
          <TextField
            id="unit"
            label="Unidad"
            value={`${vehicleOverview?.unit || ""}`}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid size={4}>
          <TextField
            id="unit"
            label="Unidad"
            value={`${vehicleOverview?.unitNumber || ""}`}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid size={4}>
          <TextField
            id="vehiclePlate"
            label="Placa del Vehículo"
            value={`${vehicleOverview?.vehiclePlate || ""}`}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid size={4}>
          <TextField
            id="isGasUnit"
            label="Es Unidad de Gas"
            value={`${vehicleOverview?.isGasUnit || ""}`}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid size={4}>
          <TextField
            id="startTripLocation"
            label="Lugar de Salida"
            value={`${vehicleOverview?.startTripLocation || ""}`}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid size={4}>
          <TextField
            id="startingTime"
            label="Hora de Inicio"
            value={`${vehicleOverview?.startingTime || ""}`}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid size={4}>
          <TextField
            id="startingFuelLevel"
            label="Combustible al Inicio"
            value={`${vehicleOverview?.startingFuelLevel || ""}`}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid size={4}>
          <TextField
            id="startingKmReading"
            label="KM Salida"
            value={`${vehicleOverview?.startingKmReading || ""}`}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid size={4}>
          <TextField
            id="fuelSupplied"
            label="Se suministró Combustible ? "
            value={`${vehicleOverview?.fuelSupplied || ""}`}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid size={4}>
          <TextField
            id="fuelSuppliedVolume"
            label="Cantidad de Combustible Suministrado"
            value={`${vehicleOverview?.fuelSuppliedVolume || ""}`}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid size={4}>
          <TextField
            id="endTripLocation"
            label="Lugar de Salida"
            value={`${vehicleOverview?.endTripLocation || ""}`}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid size={4}>
          <TextField
            id="endingTime"
            label="Hora de Llegada"
            value={`${vehicleOverview?.endingTime || ""}`}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid size={4}>
          <TextField
            id="endingFuelLevel"
            label="Combustible al Llegar"
            value={`${vehicleOverview?.endingFuelLevel || ""}`}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid size={4}>
          <TextField
            id="endingKmReading"
            label="KM Llegada"
            value={`${vehicleOverview?.endingKmReading || ""}`}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid size={12}>
          <TextField
            id="outlined-observations-static"
            label="Observaciones"
            multiline
            rows={4}
            value={vehicleOverview?.observations || ""}
            fullWidth
          />
        </Grid>
      </Grid>
    </Box>
  )
}
